import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { StatefulService } from '@app/service/stateful.service';

/**  Use const due to small list of proper noun */
export const ProperNounPatterns = ['-name', '-city'];

/** Textbox field to display obfuscated value */
@CoreBuildingBlock('input-mask')
@Component({
  selector: 'cu-input-mask',
  styleUrls: ['./input-mask.component.scss'],
  templateUrl: './input-mask.component.html',
  standalone: false
})
export class InputMaskComponent extends CoreBuildingBlockControlBaseComponent implements OnInit, OnDestroy {
  @ViewChild('input', { static: false }) public input: ElementRef;

  private readonly statefulService = inject(StatefulService);
  public pattern = { 0: { pattern: new RegExp('\\d'), symbol: '*' } };
  public hidden = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public maskData: any = '';
  public maskpattern = '';
  private storagePath = '';
  private ssnSubsFun = undefined;

  public ngOnInit(): void {
    this.setSecrityData();
    /** Call parent method init to set default value */
    super.ngOnInit();
    this.subscribeValueChange();
  }

  private subscribeValueChange(): void {
    if (this.field && this.field.config && this.field.config.storageId) {
      this.storagePath = this.field.config.storageId.replace('mem:', 'api:');
      this.ssnSubsFun = () => {
        this.setSecrityData();
        this.maskSecurityIdentity();
      };
      this.statefulService.wrap(this.storagePath, this.field.iterationId, this.page.pageIterationId).onChange(this.ssnSubsFun);
    }
  }

  public unhide() {
    this.hidden = !this.hidden;
    setTimeout(() => {
      this.maskData = this.statefulService.wrap(
        this.field.config.storageId.replace('mem:', 'api:'),
        null,
        this.field.pageIterationId
      ).value;
    }, 10);
    this.changeDetectorRef.detectChanges();
  }

  public setSecrityData(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value: any = this.statefulService.wrap(
      this.field.config.storageId.replace('mem:', 'api:'),
      null,
      this.field.pageIterationId
    ).value;
    this.maskData = this.statefulService.wrap(this.field.config.storageId, null, this.field.pageIterationId).value = value || '';
  }

  public maskSecurityIdentity(): void {
    const storageId = this.field.data.config.id;
    const iterationId = this.field.iterationId;
    const pageIterationId = this.field.pageIterationId;

    if (this.maskData && this.hidden) {
      this.statefulService.wrap(storageId, iterationId, pageIterationId).value = this.maskData.replace(/\d/g, '*');
      this.field.data.value = this.maskData.replace(/\d/g, '*');
      this.statefulService.wrap(storageId.replace('mem:', 'api:'), iterationId, pageIterationId).value = this.maskData;
    }
    if (this.maskData && !this.hidden) {
      this.statefulService.wrap(storageId, iterationId, pageIterationId).value =
        this.field.config.mask === 'ssn' ? this.formatSocialSecurity() : this.formatEin();
      this.statefulService.wrap(storageId.replace('mem:', 'api:'), iterationId, pageIterationId).value = this.maskData;
    }
    if (!this.maskData) {
      this.statefulService.wrap(storageId, iterationId, pageIterationId).value = '';
    }
  }

  public formatSocialSecurity() {
    let val = this.maskData;
    val = val.replace(/\D/g, '');
    val = val.replace(/^(\d{3})/, '$1-');
    val = val.replace(/-(\d{2})/, '-$1-');
    val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');
    return val;
  }

  public formatEin() {
    let val = this.maskData;
    val = val.replace(/\D/g, '');
    val = val.replace(/^(\d{2})/, '$1-');
    val = val.replace(/-(\d{7})/, '-$1');
    return val;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.ssnSubsFun) {
      this.statefulService.wrap(this.storagePath, this.field.iterationId, this.page.pageIterationId).unsubscribe(this.ssnSubsFun);
    }
  }
}
